// Safely access a deeply nested object property
//
// Example:
// const props = {
//   user: {
//     posts: [
//       { title: 'Foo', comments: [ 'Good one!', 'Interesting...' ] },
//       { title: 'Bar', comments: [ 'Ok' ] },
//       { title: 'Baz', comments: [] },
//     ]
//    }
//   }
//
// const getUserComments = nestedProperty(['user', 'posts', 0, 'comments'])
// note - this can be replaced with Ramda.pathOr
export default (path, obj) => path.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), obj)
